/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_DueInputs */

const cs_field_due = /** @type {(inputs: Field_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termín`)
};

const en_field_due = /** @type {(inputs: Field_DueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Due`)
};

/**
* | output |
* | --- |
* | "Due" |
*
* @param {Field_DueInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const field_due = /** @type {((inputs?: Field_DueInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_DueInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_due(inputs)
	return cs_field_due(inputs)
});